export const DELIVERY_ZIPCODE_GET = 'DELIVERY_ZIPCODE_GET';
export const DELIVERY_ZIPCODE_GET_REQUEST_SUCCESS = 'DELIVERY_ZIPCODE_GET_REQUEST_SUCCESS';
export const DELIVERY_ZIPCODE_GET_REQUEST_FAILURE = 'DELIVERY_ZIPCODE_GET_REQUEST_FAILURE';
